module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-report-4.4fe6afe6.svg";